export const Arrow = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='mask0_11814_272388'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='4'
      y='5'
      width='11'
      height='10'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.60863 6.27532C9.85271 6.03124 9.85271 5.63551 9.60863 5.39143C9.36455 5.14735 8.96882 5.14735 8.72475 5.39143L4.62879 9.48739C4.34566 9.77052 4.34566 10.2296 4.62879 10.5127L8.72475 14.6086C8.96882 14.8527 9.36455 14.8527 9.60863 14.6086C9.85271 14.3646 9.85271 13.9688 9.60863 13.7248L5.88391 10L9.60863 6.27532ZM14.6086 6.27532C14.8527 6.03124 14.8527 5.63551 14.6086 5.39143C14.3646 5.14735 13.9688 5.14735 13.7247 5.39143L9.62879 9.48739C9.34566 9.77052 9.34566 10.2296 9.62879 10.5127L13.7247 14.6086C13.9688 14.8527 14.3646 14.8527 14.6086 14.6086C14.8527 14.3646 14.8527 13.9688 14.6086 13.7248L10.8839 10L14.6086 6.27532Z'
        fill='black'
      />
    </mask>
    <g mask='url(#mask0_11814_272388)'>
      <rect width='20' height='20' fill='white' />
    </g>
  </svg>
)
